import { EPaymentMethodId } from '../order'

const getPaymentMethod = (): EPaymentMethodId => {
    return typeof window !== 'undefined' ? localStorage.getItem('paymentMethod')?.toLowerCase() as EPaymentMethodId : null
}

const setPaymentMethod = (paymentMethodId: EPaymentMethodId): void => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('paymentMethod', paymentMethodId)
    }
}

export {
    getPaymentMethod,
    setPaymentMethod
}
